// extracted by mini-css-extract-plugin
export default {"avatar-group":"tldzn_","avatarGroup":"tldzn_"};